import { Navigate } from 'react-router-dom';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import Dashboard from 'src/pages/Dashboard';
import RoleBased from 'src/components/RoleBased';
import Unauthorized from 'src/pages/Unauthorized';
import { PortalRole } from 'src/backend';
import MachineGroupDetails, {
  routes as machineGroupDetailsRoutes,
} from 'src/pages/MachineGroupDetails';
import { MachineGroupProvider } from 'src/pages/MachineGroupDetails/MachineGroupContext';
import MediaManagementDashboard from 'src/pages/MediaManagement/MediaManagementDashboard';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import AdminDashboard, {
  routes as adminDashboardRoutes,
} from 'src/pages/AdminDashboard';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { RouteProps } from './types';
import * as ROUTES from './constants';

export const routes: RouteProps[] = [
  {
    path: ROUTES.ROOT,
    element: <Navigate to={ROUTES.DASHBOARD} replace />,
  },
  {
    path: ROUTES.ROOT,
    element: <Navigate to={ROUTES.UNAUTHORIZED} replace />,
  },
  {
    path: ROUTES.DASHBOARD,
    element: (
      <RoleBased
        shouldRedirect
        requiredRole={PortalRole[PortalRole.User]}
        component={<Dashboard />}
      />
    ),
    meta: {
      title: 'Dashboard',
      icon: MonitorHeartOutlinedIcon,
      accessRole: PortalRole[PortalRole.User],
    },
  },
  {
    path: ROUTES.MEDIA,
    element: (
      <RoleBased
        shouldRedirect
        requiredRole={PortalRole[PortalRole.User]}
        component={<MediaManagementDashboard />}
      />
    ),
    meta: {
      title: 'Media Management',
      icon: PermMediaIcon,
      accessRole: PortalRole[PortalRole.User],
    },
  },
  {
    path: ROUTES.ADMIN_PANEL,
    element: (
      <RoleBased
        shouldRedirect
        requiredRole={PortalRole[PortalRole.Admin]}
        component={<AdminDashboard />}
      />
    ),
    children: adminDashboardRoutes,
    meta: {
      title: 'Admin Panel',
      icon: ManageAccountsOutlinedIcon,
      accessRole: PortalRole[PortalRole.Admin],
    },
  },
  {
    path: ROUTES.MACHINE_GROUP_DETAILS,
    element: (
      <RoleBased
        shouldRedirect
        requiredRole={PortalRole[PortalRole.User]}
        component={
          <MachineGroupProvider>
            <MachineGroupDetails />
          </MachineGroupProvider>
        }
      />
    ),
    children: machineGroupDetailsRoutes,
    meta: {
      title: 'Machine Group Details',
      navLink: false,
      accessRole: PortalRole[PortalRole.User],
    },
  },
  {
    path: ROUTES.UNAUTHORIZED,
    element: <Unauthorized />,
    meta: {
      title: 'Unauthorized',
      navLink: false,
    },
  },
];
